import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {
  Link, NavLink, useNavigate, useSearchParams,
} from 'react-router';
import { intlShape } from '../components/base/IntlProviderWrapper';
import TooltipWithPortal from '../components/base/Tooltip/TooltipWithPortal';
import {
  APPLICATION_STATUS_NAMES,
  CARRIER_STATUS_NAMES,
  CHECK_STATUS_NAMES,
  DOCUMENT_STATUS_NAMES,
  CHECK_STATUS,
  SZLT_STATUS_NAMES,
  USER_TYPE,
  VEHICLES_STATUS_NAMES,
  SUBJECT_TYPE,
  REGISTRY_TYPE, APPLICATION_SUBJECT_TYPES, CARRIER_SUBJECT_TYPES, IN_REQUEST_INF_STATUS, DICT_VEHICLE_STATUS_NAMES,
  VIOLATION_STATUS, DOCUMENT_STATUS,
} from '../configs';
import {
  getExt, getFieldValidation, getKeyByValue, propsToRow, RegNumEnToRu,
} from './utils';
import CheckBoxInput from '../components/fields/CheckBoxInput/CheckBoxInput';
import { Col, Icons } from '../components/base/BootstrapComponents/BootstrapComponents';
import renderMessage from '../components/fields/renderMessage';

export const optionClassFormatter = item => {
  let status = item;
  if (typeof item === 'object') {
    status = item.value;
  }
  return 'unknown-state';
};

export const dateFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  let d = a;
  if (typeof a === 'string') {
    const m = moment(a);
    if (!m.isValid()) {
      return a;
    }
    d = m.toDate();
  }
  return formatDate(d, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const dateTimeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  const date = formatDate(a, { year: 'numeric', month: 'numeric', day: 'numeric' }).replace(',', ' ');
  const time = formatDate(a, { hour: 'numeric', minute: 'numeric', second: 'numeric' }).replace(',', ' ');

  return (<div className="dt-formatter"><div className="dt-date">{date}</div><div className="dt-time">{time}</div></div>);
};

export const szltStatusFormatter = (status, data) => statusFormatter(status, 'szlt.status', SZLT_STATUS_NAMES);

export const smevStatusOperation = status => {
  let statusName = 'error';
  if (status === 2) {
    statusName = 'success';
  }
  if (status === 1) {
    statusName = 'dont-start';
  }
  if (status === 4) {
    statusName = 'warning';
  }
  return (
    <div className="smev-status-operation">
      <div className="smev-status-icon-wrapper">
        <div className={classNames('smev-status-icon', statusName)} />
      </div>
      <div className="smev-status-text">{localeFormatter('check.status', status)}</div>
    </div>
  );
};

export const infoFormatter = (l, v, formMeta = null, name = '', columns) => {
  const addProps = {};
  if (columns) {
    addProps.columns = columns;
  }
  return (
    <Col className="info-formatter" {...addProps}>
      {formMeta ? metaDataFormatter(formMeta, name, l) : null}
      <div className="info-label">{l}</div>
      <div className="info-value">{v || 'Нет данных'}</div>
    </Col>
  );
};

export const infoFormatterIntl = (id, v, formMeta = null, name, columns) => {
  const { formatMessage } = intlShape;
  return infoFormatter(formatMessage({ id }), v || formatMessage({ id: 'no.data.available' }), formMeta, name, columns);
};

export const renderExtIcon = mime => {
  const ext = getExt(mime);
  const iconMap = {
    tables: ['xls', 'csv', 'ods', 'fnc'],
    images: ['png', 'jpg', 'pcx'],
    imagesByte: ['bmp', 'tif', 'gif'],
    presentations: ['key', 'pps', 'ppt'],
    pdf: ['pdf'],
    archive: ['rar', 'zip', 'tgz', 'gz'],
    docs: ['doc', 'docx', 'txt', 'rtf'],
    video: ['flv', 'mp4', 'avi', 'mkv', 'mov', 'mpg'],
  };
  const iconClass = Object.keys(iconMap).filter(key => iconMap[key].includes(ext)).join(' ');
  return (
    <div className="file-ext-icon">
      <Icons
        customIcon
        icon={ext ? 'file-ext' : 'file-ext-error'}
        className={iconClass}
      />
      <div className="file-ext-text">{ext}</div>
    </div>
  );
};

export const getLegalEntityName = item => (item && item.legal_entity_type === USER_TYPE.LEGAL ? legalNameFormatter(item) : userFIOFormatter(item));

export const legalNameFormatter = user => {
  if (user && (user.full_name || user.short_name)) {
    return user.short_name || user.full_name;
  }
  return '';
};

export const userShortFIOFormatter = user => userFIOFormatter(user, true);

export const userFIOFormatter = (user, short = false) => {
  if (user) {
    if (!user.last_name && !user.lastName && !user.firstName && !user.firstName && !user.middle_name && !user.middle_name) {
      return user?.short_name;
    }

    if (short) {
      return `${user.last_name || user.lastName || ''} ${user.firstName ? `${user.firstName[0]}.` : ''}${user.first_name ? `${user.first_name[0]}.` : ''}${user.middleName ? `${user.middleName[0]}.` : ''}${user.middle_name ? `${user.middle_name[0]}.` : ''}`;
    }
    return `${user.lastName || user.last_name || ''} ${user.firstName || user.first_name || ''} ${user.middleName || user.middle_name || ''}`.trim();
  }
  return '';
};

export const localeFormatter = (key, value) => {
  const { formatMessage } = intlShape;
  if (typeof value === 'undefined' || value === null) return '';
  return formatMessage({ id: `${key}.${value}`, defaultMessage: ' ' });
};

export const userPositionFormatter = item => (
  <div className="user-position-formatter">
    <Icons customIcon icon="user-prof" />
    <div className="user-position-formatter-info">
      <div className="user-position-formatter-name">{(item && item.full_name) || 'Автоматизация'}</div>
      {/* <div className="user-position-formatter-position">{(item && item.position) || 'Нет информации'}</div> */}
    </div>
  </div>
);

export const smevCheckFormatter = (_, item = {}) => {
  const { type, status } = item;
  return (
    <div className="smev-check-formatter">
      <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
      <div className="smev-check-text">{type && type.name ? type.name : ''}</div>
    </div>
  );
};
export const smevCheckStatusFormatter = (_, item = {}) => {
  const { status } = item;
  return (
    <div className="smev-check-formatter">
      <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
    </div>
  );
};

export const orderServiceFormatter = (list = []) => list.map(os => (os.order_service_number ? os.order_service_number : '')).filter(f => !!f).join(', ');

export const renderRegistryOption = item => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  return (
    <div className="registry-select-item">
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-number">№ {number || ''}</div>
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          ИНН: {applicant.inn} ОГРН: {applicant.ogrn} Дата: {dateFormatter(applicant.decision_date)}
        </div>
      </div>
      <div className="registry-select-status">
        {szltStatusFormatter(applicant.status)}
      </div>
    </div>
  );
};

export const renderRegistryOptionMin = item => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  const statusClass = !Number.isNaN(applicant?.status) ? SZLT_STATUS_NAMES[Number(applicant?.status)] || 'denied' : 'denied';
  return (
    <div className={classNames('registry-select-item', statusClass)}>
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-number">№ {number || ''}</div>
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          {applicant?.inn ? `ИНН: ${applicant.inn}` : ''}{applicant?.ogrn ? ` ОГРН: ${applicant.ogrn}` : ''}{dateFormatter(applicant?.decision_date || applicant?.effective_date) ? ` Дата: ${dateFormatter(applicant?.decision_date || applicant?.effective_date)}` : ''}
        </div>
      </div>
    </div>
  );
};

export const registryLinksFormatterWithStatus = (type = '', registries = []) => (
  <div className="registry-links-formatter">
    {(registries || []).map((item, index) => (
      registryLinkFormatterWithStatus(item?.number, type, { registry_id: item?.id }, item)
    ))}
  </div>
);

export const registryLinkFormatterWithStatus = (content = '', type = '', params = {}, registry) => {
  const statusClass = registry?.status ? SZLT_STATUS_NAMES[Number(registry?.status)] || 'denied' : 'denied';
  return (
    <div className={classNames('registry-link-formatter', statusClass)}>
      {registryLinkFormatter(content, type, params)}
    </div>
  );
};

export const registryLinkFormatter = (content = '', type = '', params = {}) => {
  const searchParams = new URLSearchParams(params);

  let registryLink = '/region-registry-carrier';
  if (type === REGISTRY_TYPE.ORDER_SERVICE) {
    registryLink = '/region-registry/szlt';
  }
  if (type === REGISTRY_TYPE.VEHICLE) {
    registryLink = '/region-registry/passenger-taxi';
  }

  return (
    <NavLink
      to={{
        pathname: registryLink,
        search: searchParams.toString(),
      }}
      target="_blank"
    >
      {content}
    </NavLink>
  );
};

export const metaDataFormatter = (formMeta = {}, name = '', label = '') => {
  if (!formMeta.check_errors && !formMeta.errors) {
    return null;
  }
  const validationData = getFieldValidation(formMeta, name || '');
  const renderErrors = errors => (errors.length ? (errors || []).join(', ') : 'Ошибок нет');
  return (
    <div className="meta-data">
      {
        validationData && Object.keys(validationData)
          ? (
            <TooltipWithPortal
              classNameWrapper="meta-data-dropdown"
              tooltipContent={(
                <div className="meta-data-information">
                  <div className="meta-data-label">{label}</div>
                  <div className="meta-data-row meta-data-check-errors">{renderErrors(validationData?.errors)}</div>
                  <div className="meta-data-row meta-data-errors">{renderErrors(validationData?.check_errors)}</div>
                </div>
              )}
              content={(
                <>
                  <div
                    className={classNames('meta-data-indicator meta-data-validate-1', { error: Object.keys(validationData?.errors).length })}
                  />
                  <div
                    className={classNames('meta-data-indicator meta-data-validate-2', { error: Object.keys(validationData?.check_errors).length })}
                  />
                </>
              )}
            />
          )
          : null
      }
    </div>
  );
};

export const convertActivityLog = (data, key) => {
  const { formatMessage } = intlShape;
  // if ((String(key).includes('_at') || String(key).includes('_date')) && typeof data === 'string') {
  //   return dateTimeFormatter(data);
  // }
  if (key === 'order_services_attach') {
    return orderServiceFormatter(data || []);
  }
  if (Array.isArray(data)) {
    return data.map((a, i) => convertActivityLog(a, i)).join(', ');
  }
  if (data && typeof data === 'object') {
    const clearAttributes = clearActivityLog(data);
    return Object.keys(clearAttributes).map(key => `${formatMessage({ id: key, defaultMessage: key })}: ${convertActivityLog(clearAttributes[key], key)}`).join(', ');
  }
  return data || '';
};

export const clearActivityLog = (obj = {}) => Object.keys(obj).reduce((acc, key) => {
  if (String(key).includes('_label')) return acc;
  let value = obj[key];
  if (obj && typeof obj[`${key}_label`] !== 'undefined') {
    value = obj[`${key}_label`];
  }
  acc[key] = value;
  return acc;
}, {});

export const formatFioForAvatar = user => {
  const { last_name, first_name } = user;
  const getInitial = name => (name ? name.charAt(0).toUpperCase() : '');
  return `${getInitial(last_name)}${getInitial(first_name)}`;
};

export const applicationStatusOperation = (status, text) => {
  let statusName = '';
  if (status === 1) {
    statusName = 'oneDay';
  }
  if (status === 2) {
    statusName = 'twoDay';
  }
  if (status === 3) {
    statusName = 'expired';
  }
  if (status === 4) {
    statusName = 'is_archive';
  }
  return (
    <div className="application-status-operation">
      <div className="application-status-icon-wrapper">
        <div className={classNames('application-status-icon', statusName)} />
      </div>
      <div className="application-status-text">{text}</div>
    </div>
  );
};

export const procedureTypeFormatterWithStatus = (procedure, status) => {
  const { formatMessage } = intlShape;
  return (
    <div className="application-procedure-type-formatter">
      <div className={classNames('application-procedure-type-formatter-status', { isError: !status })} />
      {formatMessage({ id: `procedure.type.${procedure}` })}
    </div>
  );
};

export const statusFormatter = (status, statusName = 'application.status', statusNames = APPLICATION_STATUS_NAMES) => {
  const { formatMessage } = intlShape;
  const statusClass = !Number.isNaN(status) ? statusNames[Number(status)] || 'denied' : 'denied';
  return (
    <div className={classNames('application-status', statusClass)}>
      <div className="application-status-icon">
        <Icons width={30} height={30} customIcon icon={statusClass} className="button-icons" />
      </div>
      <div className="application-status-text">
        {formatMessage({ id: `${statusName}.${status}` })}
      </div>
    </div>
  );
};

export const applicantTypeFormatter = (type = 0) => {
  const { formatMessage } = intlShape;
  return (
    <div className={classNames('applicant-type-formatter', { isError: !type })}>
      <div className="applicant-type-formatter-status-icon">
        <Icons width={30} height={30} customIcon icon={`applicant-status-${type}`} className="button-icons" />
      </div>
      <div className="applicant-type-formatter-status-text">
        {formatMessage({ id: `applicant.type.${type}` })}
      </div>
    </div>
  );
};
export const subjectFormatterForNotification = (item = {}) => {
  const {
    source_subject_type, subject_type, source_subject_id, subject_id, subject, source_subject, data, subject_label, source_subject_label,
  } = item;

  const id = source_subject_id || subject_id;
  const type = source_subject_type || subject_type;
  const obj = source_subject || subject;
  const label = subject_label || source_subject_label;

  if (SUBJECT_TYPE.ROLLBACK_PLAN === type) {
    return <div>{label}</div>;
  }

  if (SUBJECT_TYPE.WAYBILL === type) {
    return (
      <NavLink to={`/waybill?waybill_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (APPLICATION_SUBJECT_TYPES.includes(type)) {
    return (
      <NavLink to={`/application?application_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (CARRIER_SUBJECT_TYPES.includes(type)) {
    return registryLinkFormatter(label, REGISTRY_TYPE.CARRIER, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.ORDER_SERVICE) {
    return registryLinkFormatter(label, REGISTRY_TYPE.ORDER_SERVICE, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.VEHICLE) {
    return registryLinkFormatter(label, REGISTRY_TYPE.VEHICLE, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.APPLICANT) {
    return (
      <NavLink to={`/applicants?applicant_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (type === SUBJECT_TYPE.DOCUMENT) {
    return (
      <NavLink to={`/application/await-document?document_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (!subject_type && !source_subject_type) {
    return '';
  }

  return label;
};

export const subjectFormatter = (item = {}) => {
  const {
    source_subject_type, subject_type, source_subject_id, subject_id, subject, source_subject,
  } = item;

  const id = source_subject_id || subject_id;
  const type = source_subject_type || subject_type;
  const obj = source_subject || subject;

  return (
    <>
      {APPLICATION_SUBJECT_TYPES.includes(type) ? (
        <NavLink to={`/application?application_id=${id}`}>
          {localeFormatter('subject.type', type)} № {obj?.mais_egu_id || 'Без номера'} от {dateFormatter(obj?.applied_at) || 'Без даты'}
        </NavLink>
      ) : null}
      {CARRIER_SUBJECT_TYPES.includes(type) ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.CARRIER, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.ORDER_SERVICE ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.ORDER_SERVICE, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.VEHICLE ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.VEHICLE, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.DOCUMENT ? (
        <NavLink to={`/application/await-document?document_id=${id}`}>
          {localeFormatter('subject.type', type)} № {obj?.number || 'Без номера'} от {dateFormatter(obj?.created_at) || 'Без даты'}
        </NavLink>
      ) : null}
    </>
  );
};

export const tooltipFormatter = a => {
  if (!a) {
    return '';
  }
  return <TooltipWithPortal className="tooltip-formatter" content={a} />;
};

export const inRequestInfStatusFormater = status => {
  const isSuccess = IN_REQUEST_INF_STATUS.SUCCESS === status;
  return (
    <div className={classNames('in-request-inf-status-formater', { error: !isSuccess })}>
      <Icons customIcon width={20} height={20} icon={isSuccess ? 'success' : 'denied'} />
      <div>{localeFormatter('in_request_inf.status', status)}</div>
    </div>
  );
};

export const timeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const dateTimeStringFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  const date = formatDate(a, { year: 'numeric', month: 'numeric', day: 'numeric' }).replace(',', ' ');
  const time = formatDate(a, { hour: 'numeric', minute: 'numeric', second: 'numeric' }).replace(',', ' ');

  return `${date} ${time}`;
};

export const vehicleRegisterStatusFormatter = (status, data) => statusFormatter(status, 'vehicle.register.status', DICT_VEHICLE_STATUS_NAMES);

export const violationStatusFormatter = status => (
  <div className={classNames('violation-status-formatter', status)}>
    <Icons customIcon icon={status === VIOLATION_STATUS.ACTIVE ? 'applicant-success' : 'applicant-denied'} />
    {localeFormatter('violation.status', status)}
  </div>
);

export const smevCheckWithContentFormatter = (content, status = '', federal_law_number = '') => (
  <div className="smev-check-formatter">
    <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
    <div className="smev-check-text">{content || ''}</div>
    { federal_law_number ? federalFawFormatter(federal_law_number) : null }
  </div>
);

export const vehiclesStatusFormatter = (status, data) => statusFormatter(status, 'vehicles.status', VEHICLES_STATUS_NAMES);

export const federalFawFormatter = federal_law => (
  <div className="federal-law-formatter">
    {federal_law || 'Не указан'}
  </div>
);

export function MenuAfterShowNewExportImport({ path = '' }) {
  return (
    <>
      <Link to={`${path}?new=1`} title="Создать новую запись" className="after-button ms-auto"><Icons
        customIcon
        icon="square"
        width={24}
        height={24}
      />
      </Link>
      <Link to={`${path}?export=1`} title="Экспорт реестра" className="after-button"><Icons
        customIcon
        icon="download"
        width={24}
        height={24}
      />
      </Link>
      <Link to={`${path}?import=1`} title="Импорт реестра" className="after-button"><Icons
        customIcon
        icon="upload"
        width={24}
        height={24}
      />
      </Link>
    </>
  );
}

export const carrierStatusFormatter = (status, data) => statusFormatter(status, 'carrier.status', CARRIER_STATUS_NAMES);
export const orderServiceFormatter2 = (list = []) => (Array.isArray(list) ? list.map(os => (os.number ? os.number : '')).filter(f => !!f).join(', ') : []);
export const vehiclesFormatter = (list = []) => (Array.isArray(list) ? list.map(os => (os.number ? os.number : '')).filter(f => !!f).join(', ') : []);

export const documentListStatusFormatter = (status, data) => {
  const statusClass = !Number.isNaN(status) && !(status === DOCUMENT_STATUS.CREATED && data?.type === 1) ? DOCUMENT_STATUS_NAMES[Number(status)] || '' : '';
  return (
    <div className="documents-status">
      <div className="documents-status-icon">
        <Icons customIcon icon={statusClass} />
      </div>
    </div>
  );
};

export const settingActiveStatusFormatter = status => (
  <div className={classNames('setting-active-status-formatter', { isActive: status })}>
    {status ? 'Активен' : 'Неактивен'}
  </div>
);

export const renderApplicantOptionMin = (item = {}) => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  const statusClass = !Number.isNaN(applicant?.status) ? SZLT_STATUS_NAMES[Number(applicant?.status)] || 'denied' : 'denied';
  const dataList = [];
  if (applicant?.inn) {
    dataList.push(`ИНН: ${applicant.inn}`);
  }
  if (applicant?.ogrn) {
    dataList.push(`ОГРН: ${applicant.ogrn}`);
  }
  if (applicant?.created_at) {
    dataList.push(`Дата: ${dateFormatter(applicant?.created_at)}`);
  }

  return (
    <div className={classNames('registry-select-item', statusClass)}>
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          {dataList.join(' • ')}
        </div>
      </div>
    </div>
  );
};

export const formatRegistryNumber = (numbers = [], registry_subjects, registry_subject, registryType, fieldsValidation, keyPrefix = '') => {
  const hasMultipleSubjects = registry_subjects && registry_subjects.length > 0;

  const translationKey = (keyPrefix ? `${keyPrefix}.` : '') + (hasMultipleSubjects ? 'registry.numbers' : 'registry.number');
  const fieldName = hasMultipleSubjects ? 'numbers' : 'number';
  const isNoData = !numbers.length;
  const dataRender = (numbers || []).map((n, key) => {
    const item = (registry_subjects || []).find(i => i.number === n);
    return (
      <div key={key}>
        {registryLinkFormatter(
          renderRegistryOptionMin({ applicant: { ...item }, number: item?.number || n }),
          registryType,
          { registry_id: item?.id },
        )}
      </div>
    );
  });
  return infoFormatterIntl(
    translationKey,
    <div className="registry-number-list">
      {isNoData ? 'Данные отсутствуют' : dataRender}
    </div>,
    fieldsValidation,
    fieldName,
  );
};

export const renderValidationMessage = (errors, checkErrors, checkErrorsKeys, errorsKeys) => (
  <div className="validation-block">
    {checkErrorsKeys && checkErrorsKeys.length ? <div className="f4">Ошибки валидации полей</div> : null}
    {errorsKeys.map((e, key) => (
      <div
        key={`errors-keys-${key}`}
      >{infoFormatterIntl(String(e).split('.').pop(), propsToRow(errors[e]?.messages || ''))}
      </div>
    ))}
    {checkErrorsKeys && checkErrorsKeys.length ? <div className="f4 mt-3">Ошибки валидации РСМЭВ</div> : null}
    {checkErrorsKeys.map((e, key) => {
      if (checkErrors[e].status === 2) { return null; }
      return (<div key={`check-errors-keys-${key}`}>{infoFormatterIntl(String(e).split('.').pop(), propsToRow((checkErrors[e]?.errors || []).map(ei => ei?.message || '').filter(f => !!f).join(', ') || ''))}</div>);
    })}
  </div>
);
